import { render, staticRenderFns } from "./ServiceCreation.vue?vue&type=template&id=0b0c6a46&scoped=true&"
import script from "./ServiceCreation.vue?vue&type=script&lang=js&"
export * from "./ServiceCreation.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCreation.vue?vue&type=style&index=0&id=0b0c6a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c6a46",
  null
  
)

export default component.exports